import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { BeketSearchForm } from 'widgets/beket/beket-search-form'
import { CountAndClass } from 'widgets/level-class-count'

import findTicketFormStore from 'entities/beket/models/find-ticket/find-ticket-store'

import { HeaderGoBack } from 'shared/ui/header-go-back'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

const BeketSearchFormPage = observer(() => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const onChangeSearch = (data?: CountAndClass) => {
    findTicketFormStore.onSetCount(data, true)
  }

  const onSwitchDirection = () => {
    findTicketFormStore.onSwitchDirectionCopy(0)
  }

  const onSearch = () => {
    findTicketFormStore.setCopyForSearch()

    navigate(RoutingPaths.beket.searchResults.path())
  }

  const onGoBack = () => {
    findTicketFormStore.resetDirectionCopy()

    navigate(-1)
  }

  useEffect(() => {
    !findTicketFormStore?.copyFormFindTicket &&
      findTicketFormStore.onSetDataCopy()
  }, [])

  return (
    <div className={clsx('container', s.container)}>
      <div className={s.header}>
        <HeaderGoBack
          title={t('edit_search')}
          onGoBack={onGoBack}
          buttonWhite
        />
      </div>

      <Paper
        padding={[16]}
        radius={'28px'}
      >
        <div className={s.wrapper}>
          <p className={clsx(s.title, 'extra-bold-24')}>
            {t('beket.page.title')}
          </p>

          <p className={clsx(s.subTitle, 'regular-14')}>
            {t('beket.page.sub_title')}
          </p>
        </div>

        <BeketSearchForm
          isSearch
          isAvailable
          type="lightGrey"
          onSearch={onSearch}
          onChange={onChangeSearch}
          onSwitch={onSwitchDirection}
          searchData={findTicketFormStore.copyFormFindTicket || {}}
        />
      </Paper>
    </div>
  )
})

export default BeketSearchFormPage
